import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";

const Stars = ({ n, size = "w-4 h-4" }) => <span className="inline-flex">{[1, 2, 3, 4, 5].map(i => <Star key={i} className={`${size} ${i <= Math.round(n) ? "fill-yellow-400 text-yellow-400" : "text-slate-300"}`} />)}</span>;

export const ReviewsWidget = ({ dark }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/api/reviews").then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d?.reviews?.length) return null;
  return (
    <section className={`py-12 ${dark ? "text-white" : ""}`} data-testid="reviews-widget">
      <div className="flex flex-wrap items-end gap-3 mb-6">
        <h2 className="text-2xl font-bold flex-1">What shop owners say</h2>
        {d.rating && <a href={d.maps_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm font-semibold" data-testid="reviews-summary"><Stars n={d.rating} /><span>{d.rating.toFixed(1)} · {d.count} Google reviews</span></a>}
      </div>
      <div className="grid md:grid-cols-3 gap-4">{d.reviews.slice(0, 6).map(r => (
        <figure key={r.id} className="bg-white text-slate-900 border border-slate-200 rounded-xl p-5 shadow-sm flex flex-col" data-testid={`review-${r.id}`}>
          <Stars n={r.rating} />
          <blockquote className="text-sm text-slate-700 mt-3 flex-1 line-clamp-6">“{r.text}”</blockquote>
          <figcaption className="flex items-center gap-2 mt-4">
            {r.author_photo && <img src={r.author_photo} alt="" className="w-8 h-8 rounded-full" referrerPolicy="no-referrer" />}
            <span className="text-sm"><a href={r.author_url || d.maps_url} target="_blank" rel="noopener noreferrer" className="font-semibold hover:underline">{r.author}</a><span className="block text-xs text-slate-400">{r.when} · Google</span></span>
          </figcaption>
        </figure>))}</div>
    </section>
  );
};
